// crm/src/config/roles-master.js

export const ROLES = {
    'MD Office': {
      value: 'MD Office',
      label: 'MD Office',
      color: 'bg-red-100 text-red-700 border border-red-200',
      hierarchy: 1
    },
    'Sales Manager': {
      value: 'Sales Manager',
      label: 'Sales Manager',
      color: 'bg-cyan-100 text-cyan-700 border border-cyan-200',
      hierarchy: 2
    },
    'MBD Sales Person': {
      value: 'MBD Sales Person',
      label: 'MBD Sales Person',
      color: 'bg-blue-100 text-blue-600 border border-blue-200',
      hierarchy: 3
    },
    'SOP Sales Person': {
      value: 'SOP Sales Person',
      label: 'SOP Sales Person',
      color: 'bg-orange-100 text-orange-600 border border-orange-200',
      hierarchy: 3
    },
    'Lead Generator': {
      value: 'Lead Generator',
      label: 'Lead Generator',
      color: 'bg-green-100 text-green-600 border border-green-200',
      hierarchy: 4
    },
    'Finance': {
      value: 'Finance',
      label: 'Finance',
      color: 'bg-gray-100 text-gray-700 border border-gray-200',
      hierarchy: 4
    },
  };
  
  // Helper functions for working with roles
  export const getRoleOptions = () => {
    return Object.values(ROLES).sort((a, b) => a.hierarchy - b.hierarchy);
  };
  
  export const getRoleColor = (roleValue) => {
    return ROLES[roleValue]?.color || 'bg-gray-100 text-gray-700 border border-gray-200';
  };
  
  export const getRoleLabel = (roleValue) => {
    return ROLES[roleValue]?.label || roleValue;
  };
  
  export const isValidRole = (roleValue) => {
    return roleValue in ROLES;
  };
  
  export const getRolesByHierarchy = (level) => {
    return Object.values(ROLES).filter(role => role.hierarchy === level);
  };